// extracted by mini-css-extract-plugin
export var gif = "_dp-0";